// extracted by mini-css-extract-plugin
export default {"richTextViewMode":"QuestionFieldComponent__richTextViewMode___r6QQR"};